// extracted by mini-css-extract-plugin
export var action_btn = "palette_from_image-module--action_btn--ec295";
export var active = "palette_from_image-module--active--35225";
export var change_image_button = "palette_from_image-module--change_image_button--c7af6";
export var color_code = "palette_from_image-module--color_code--f7bf6";
export var color_swatch = "palette_from_image-module--color_swatch--12282";
export var colors_from_image_wrapper = "palette_from_image-module--colors_from_image_wrapper--7a962";
export var dropzone_button = "palette_from_image-module--dropzone_button--92ade";
export var dropzone_formats = "palette_from_image-module--dropzone_formats--81c6d";
export var dropzone_hint = "palette_from_image-module--dropzone_hint--bb989";
export var dropzone_icon = "palette_from_image-module--dropzone_icon--4083c";
export var dropzone_text = "palette_from_image-module--dropzone_text--f693a";
export var dropzone_wrapper = "palette_from_image-module--dropzone_wrapper--9c931";
export var error_message = "palette_from_image-module--error_message--8db1e";
export var extracted_colors = "palette_from_image-module--extracted_colors--f62c5";
export var format_badge = "palette_from_image-module--format_badge--40536";
export var image_wrapper = "palette_from_image-module--image_wrapper--8fabb";
export var input_method = "palette_from_image-module--input_method--ffc5b";
export var input_method_active = "palette_from_image-module--input_method_active--50b25";
export var input_methods = "palette_from_image-module--input_methods--851fe";
export var method_hint = "palette_from_image-module--method_hint--72375";
export var method_panel = "palette_from_image-module--method_panel--07c7d";
export var palette_actions = "palette_from_image-module--palette_actions--0f5f6";
export var palette_from_image_wrapper = "palette_from_image-module--palette_from_image_wrapper--a05d0";
export var paste_icon = "palette_from_image-module--paste_icon--17a7b";
export var paste_panel = "palette_from_image-module--paste_panel--624b2";
export var preview_panel = "palette_from_image-module--preview_panel--04881";
export var primary_action_btn = "palette_from_image-module--primary_action_btn--f82f0";
export var primary_button = "palette_from_image-module--primary_button--75b79";
export var result_layout = "palette_from_image-module--result_layout--cca37";
export var result_status = "palette_from_image-module--result_status--ee054";
export var subtitle = "palette_from_image-module--subtitle--07732";
export var toast = "palette_from_image-module--toast--8ffb9";
export var toastIn = "palette_from_image-module--toast-in--8c53a";
export var tool_card = "palette_from_image-module--tool_card--af234";
export var tool_heading = "palette_from_image-module--tool_heading--c058e";
export var trust_signals = "palette_from_image-module--trust_signals--7a369";
export var url_form = "palette_from_image-module--url_form--df76d";
export var url_input = "palette_from_image-module--url_input--c9210";